export default {
  paymentConfigurations: (state) => state.paymentConfigurations,
};
